module.exports = __webpack_public_path__ + "media/entities/3010-808485da.png";